/* @flow */

import { useData } from "crustate/react";
import { useLocation } from "react-router-dom";
import { useClient } from "entrypoint/shared";
import { CustomerData } from "data";
import { getSASLoginUrl } from "queries";

const useCustomer = () => {
  const customerData = useData(CustomerData);
  const location = useLocation();
  const client = useClient();
  const customer = customerData.data ? customerData.data : null;
  const loggedIn = customer !== null;
  const missingAddress = Boolean(
    customer &&
    (
      !customer.firstname ||
      !customer.lastname ||
      !customer.email ||
      customer.addresses.length === 0 ||
      !customer.addresses.some(addr =>
        addr.street.length > 0 &&
        Boolean(addr.city) &&
        Boolean(addr.postcode) &&
        Boolean(addr.telephone) &&
        Boolean(addr.country.code)
      )
    )
  );

  const redirectToLogin = async (setLoading?: boolean => void) => {
    if (setLoading !== undefined && setLoading !== null) {
      setLoading(true);
    }

    // Remove login_error parameter before getSASLoginUrl call
    const params = new URLSearchParams(location.search);
    params.delete("login_error");

    const search = params.toString();
    const baseUrl = (location.pathname + (search ? `?${search}` : "")).slice(1);

    const response = await client(getSASLoginUrl, { redirect: baseUrl });

    if (response.getSASLoginUrl !== null && typeof window !== "undefined") {
      window.location.href = response.getSASLoginUrl;
    }
  };

  return {
    redirectToLogin,
    loggedIn,
    customer,
    missingAddress,
  };
};

export default useCustomer;
